import { useFeatureCardForm } from "@/components/shared/forms/feature-card-form";
import type { FeatureCard } from "@stackje/common/config";

interface EditFeatureCardProps {
  card: FeatureCard;
  cardIndex: number;
}

export function EditFeatureCard({ card }: EditFeatureCardProps) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } = useFeatureCardForm({
    initialData: {
      title: card.title || "",
      subtitle: card.subtitle || "",
      features: card.features.map(f => ({
        title: f.title || "",
        description: f.description || "",
        image: f.image || "",
      })),
      type: card.type,
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    toggleType,
    shuffleColors,
    handleSubmit,
  };
}
